#chat-message-bar {
  display: flex;
  align-items: center; // Ensure proper alignment
  gap: 0; // Remove gap initially

  &.has-text {
    gap: 10px; // Add gap when button is visible

    #chat-textarea {
      flex: 1 1 auto; // Allow shrinking
      max-width: calc(100% - 56px); // Account for button width + gap
      margin-right: 10px; // Add margin for button visibility

    }

    ux-button {
      opacity: 1; // Fade in the button
      pointer-events: auto; // Enable interaction
      position: static; // Normal flow when visible
    }
  }
}

#chat-textarea {
  flex: 1 1 100%; // Ensure full width initially
  box-sizing: border-box;
  font-family: Frutiger-Light, sans-serif;
  font-size: 16px;
  padding: 12px 30px 6px 15px;
  border: 1px solid var(--ux-input-border-color);
  resize: none;
  overflow: auto;
  overflow: hidden;
  line-height: 1;
  height: 46px;
  max-height: 120px;
  transition: flex-grow 0.3s ease, max-width 0.3s ease, margin-right 0.3s ease;

  &::placeholder {
    vertical-align: middle;
  }
}

ux-button {
  flex: 0 0 46px; // Fixed width for the button
  align-self: flex-end;
  --ux-icon-button-width: 46px;
  --ux-icon-button-height: 46px;
  --ux-button-icon-size-large: 20px;
  opacity: 0; // Initially hidden
  pointer-events: none; // Disable interaction when hidden
  position: absolute; // Remove from flow when hidden
  left: 100%;
  transition: opacity 0.3s ease;
}